var metacoinConfig = {
  
  mainnet: {
    contractAddress: "410b84765bdcf9e29777e2444f7aae6bd5921de20b",
    contractAddressBase: "TB277p9vW7B7rMe6rWotgbR5idzxV5eDjM",
    privateKey:
      "CBB6FDC134599AD3FF5D8E4A23E87EB1289BC6985A3380D8FAA35CDBA677DA05",
    fullHost: "https://api.trongrid.io",
    url : "https://tronscan.org"
  },
  shasta: {
    contractAddress: "41ea46a528240ca7ebe8b0fc384a920e332d1de6c6",
    contractAddressBase: "TXKwkTWpdcWTqLFRGMGxeJz9FFxv6maz2Q",
    privateKey:
      "CBB6FDC134599AD3FF5D8E4A23E87EB1289BC6985A3380D8FAA35CDBA677DA05",
    fullHost: "https://api.shasta.trongrid.io",
    url : "https://shasta.tronscan.org"

  },
};

export default metacoinConfig;
